import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  root: {
    width: '100%'
  },
  fullWidth: {
    width: '100%'
  },
  textfield: {
    width: '100%',
    fontSize: '0.875em'
  },
  row: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  control: {
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1)
  },
  buttonContainer: {
    // textAlign: 'right',
    // padding: theme.spacing(1)
    marginTop: theme.spacing(2)
  },

  boxGrid: {
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.white_100.main,
    border:
      theme.palette.type === 'dark'
        ? '1px solid' + theme.palette.dark_stroke.main
        : '1px solid' + theme.palette.gray_stroke.main,
    marginTop: '8px',
    borderRadius: 16,
    padding: '10px !important'
  },
  groupTitle: {
    margin: 0,
    color: theme.palette.blue_300.main,
    fontWeight: '600',
    marginBottom: '12px'
  },
  boxContentInput: {
    display: 'flex',
    gap: '8px',
    marginBottom: '8px',
    alignItems: 'flex-end',
    justifyContent: 'space-between'
  },
  helpButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    cursor: 'pointer',
    justifyContent: 'space-between'
  },
  inputButtonHelp: {
    color: theme.palette.blue_300.main,
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  boxPopover: {
    padding: 10,
    width: '300px',
    minWidth: '300px',
    fontSize: '1rem',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_600.main
        : theme.palette.gray_100.main,
    borderRadius: 8,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },

  formControl: {
    display: 'flex',
    // alignItems: 'center',
    gap: '8px'
  },
  inputWrapper: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center'
  },
  formLabel: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  textUntil: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  contentFormGrid: {
    display: 'flex',
    gap: '8px'
  },
  boxShowWeekTime: {
    border:
      theme.palette.type === 'dark'
        ? '1px solid' + theme.palette.dark_stroke.main
        : '1px solid' + theme.palette.gray_stroke.main,
    borderRadius: 16,
    padding: '10px !important'
  },

  queueContainer: {
    display: 'flex',
    gap: '8px',
    margin: '8px 0'
  },
  queueItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px',
    // gap: '8px',
    border:
      theme.palette.type === 'dark'
        ? '1px solid' + theme.palette.dark_stroke.main
        : '1px solid' + theme.palette.gray_stroke.main,
    borderRadius: 10,
    minWidth: '120px',
    cursor: 'pointer',
    height: '40px',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  iconButton: {
    backgroundColor: 'transparent',
    color: theme.palette.blue_300.main,
    padding: 0,
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },

  boxHours: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8px',
    borderRadius: 8,
    backgroundColor: theme.palette.red_200.main,
    color: theme.palette.red_100.main
  },
  serverClock: {
    width: '100%',
    minHeight: 56,
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '8px 12px',
    borderRadius: 12,
    border:
      theme.palette.type === 'dark'
        ? '1px solid' + theme.palette.dark_stroke.main
        : '1px solid' + theme.palette.gray_stroke.main,
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_600.main
        : theme.palette.gray_50.main,
    boxSizing: 'border-box'
  },
  serverClockIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.blue_300.main,
    flexShrink: 0
  },
  serverClockValueContainer: {
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
    justifyContent: 'center'
  },
  serverClockInfo: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0
  },
  serverClockLabel: {
    fontSize: '0.875rem',
    fontWeight: 600,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  serverClockValue: {
    fontSize: '1rem',
    fontWeight: 700,
    color: theme.palette.blue_300.main
  },
  serverClockTimezone: {
    fontSize: '0.75rem',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },

  buttonAddNewHour: {
    border: 'dashed 1px',
    height: '39px',
    borderRadius: 10,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_stroke.main
        : theme.palette.gray_stroke.main,
    '& span': {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main,
      '& svg': {
        color: theme.palette.blue_300.main
      }
    }
  }
}))
